function normaliseApiBaseUrl(value: string | undefined): string {
  const trimmed = value?.trim();
  if (!trimmed) {
    throw new Error('VITE_API_URL must be configured. The frontend now requires a blog API base URL.');
  }

  return trimmed.replace(/\/$/, '');
}

export const API_BASE_URL = normaliseApiBaseUrl(import.meta.env.VITE_API_URL);
